import { render, staticRenderFns } from "./OtherCompanyConstructionNewPage.vue?vue&type=template&id=29a41c9c&"
import script from "./OtherCompanyConstructionNewPage.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyConstructionNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports